<form [formGroup]="form" (ngSubmit)="submit()" class="cpm">
  <section class="form-section">
    <header class="form-section__head">
      <div class="form-section__eyebrow">
        <span class="form-section__num">1</span> Sécurité
      </div>
      <h3 class="form-section__title">Choix d'un nouveau mot de passe</h3>
      <p class="form-section__sub">
        Confirmez votre mot de passe actuel pour autoriser le changement,
        puis choisissez-en un nouveau.
      </p>
    </header>

    <div class="form-grid">
      <!-- Mot de passe actuel -->
      <div class="form-field form-field--full">
        <label class="form-field__label">
          Mot de passe actuel <span class="req">*</span>
        </label>
        <nz-input-group [nzSuffix]="currentPasswordSuffix" nzSize="large">
          <input
            [type]="showCurrentPassword ? 'text' : 'password'"
            nz-input
            formControlName="currentPassword"
            placeholder="Votre mot de passe actuel"
          />
        </nz-input-group>
        <ng-template #currentPasswordSuffix>
          <span
            nz-icon
            [nzType]="showCurrentPassword ? 'eye-invisible' : 'eye'"
            nzTheme="outline"
            (click)="toggleCurrent()"
            class="cpm__eye"
          ></span>
        </ng-template>
        <div
          class="form-field__hint cpm__hint--error"
          *ngIf="form.get('currentPassword')?.touched && form.get('currentPassword')?.invalid"
        >
          Le mot de passe actuel est requis.
        </div>
      </div>

      <!-- Nouveau mot de passe -->
      <div class="form-field form-field--full">
        <label class="form-field__label">
          Nouveau mot de passe <span class="req">*</span>
        </label>
        <nz-input-group [nzSuffix]="newPasswordSuffix" nzSize="large">
          <input
            [type]="showNewPassword ? 'text' : 'password'"
            nz-input
            formControlName="newPassword"
            placeholder="Au moins 6 caractères"
          />
        </nz-input-group>
        <ng-template #newPasswordSuffix>
          <span
            nz-icon
            [nzType]="showNewPassword ? 'eye-invisible' : 'eye'"
            nzTheme="outline"
            (click)="toggleNew()"
            class="cpm__eye"
          ></span>
        </ng-template>

        <!-- Force du mot de passe : barre + libellé -->
        <div *ngIf="form.get('newPassword')?.value" class="cpm__strength" [attr.data-level]="passwordStrength">
          <div class="cpm__strength-bars">
            <span
              *ngFor="let bar of [1, 2, 3, 4]"
              class="cpm__strength-bar"
              [class.cpm__strength-bar--filled]="bar <= passwordStrength"
            ></span>
          </div>
          <span class="cpm__strength-label">{{ passwordStrengthLabel }}</span>
        </div>

        <div
          class="form-field__hint cpm__hint--error"
          *ngIf="form.get('newPassword')?.touched && form.get('newPassword')?.invalid"
        >
          Minimum 6 caractères.
        </div>
      </div>

      <!-- Confirmation -->
      <div class="form-field form-field--full">
        <label class="form-field__label">
          Confirmer le nouveau mot de passe <span class="req">*</span>
        </label>
        <nz-input-group [nzSuffix]="confirmPasswordSuffix" nzSize="large">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            nz-input
            formControlName="confirmPassword"
            placeholder="Re-saisissez le nouveau mot de passe"
          />
        </nz-input-group>
        <ng-template #confirmPasswordSuffix>
          <span
            nz-icon
            [nzType]="showConfirmPassword ? 'eye-invisible' : 'eye'"
            nzTheme="outline"
            (click)="toggleConfirm()"
            class="cpm__eye"
          ></span>
        </ng-template>
        <div
          class="form-field__hint cpm__hint--error"
          *ngIf="form.get('confirmPassword')?.touched && form.get('confirmPassword')?.hasError('passwordMismatch')"
        >
          Les mots de passe ne correspondent pas.
        </div>
        <div
          class="form-field__hint cpm__hint--error"
          *ngIf="form.get('confirmPassword')?.touched && form.get('confirmPassword')?.hasError('required')"
        >
          La confirmation est requise.
        </div>
      </div>
    </div>
  </section>

  <div class="cpm__foot">
    <button
      nz-button
      type="button"
      (click)="close()"
      [disabled]="isSubmitting"
    >
      Annuler
    </button>
    <button
      nz-button
      nzType="primary"
      type="submit"
      (click)="submit()"
      [nzLoading]="isSubmitting"
      [disabled]="form.invalid"
    >
      Modifier
    </button>
  </div>
</form>
